import React, { useState } from "react";
import { KTSVG } from "../../../helpers";

type Props = {
  className: string;
  innerPadding?: string;
};

const StepContent5: React.FC<Props> = ({ className, innerPadding = "" }) => {
  const [category, setCategory] = useState("1");
  const [option, setOption] = useState("1");
  const [fleet, setFleet] = useState("1");
  return (

      <div className={`card ${className}`}>
        {/* begin::Body */}
        <div className={`card-body ${innerPadding}`}>
          {/* begin::Title */}
          <div className="mb-10">
            <h3 className="fw-bold text-dark mb-2 fs-3">Define customer persona</h3>
            <span className="fs-7 text-muted">
             Read each section and then fill in your answers at the bottom.
            </span>
          </div>
          {/* end::Title */}

          {/* begin::Section */}
          <div className="mb-10">
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-7 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    Define customer persona
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  In this step you will describe a persona (a detailed description of one potential, real end user). The persona ensures that everyone is unambiguously focused on the same target and you are focused on the customer (not your wants) and what will make them more successful. This will make the customer very real to the team.

                  If prepared well and displayed conspicuously, the persona will serve as a constant and fresh reminder to you and your team. It is important to review it regulary. Print it out and, put it on wall everyone can't help but see it. A paying—or monetizable—customer is the most important element for any business.

                  This is also one of the most fun and unifying steps in the DE Toolbox. It makes your target customer tangible so that all members of the founding team, and all employees, have absolute clarity and focus on the same goal of making their target customer successful and happy. Rather than guessing or arguing internally about what potential customers might want, the persona answers these questions definitively. It is a powerful tool for aligning the team and keeping everyone focused on the customer. 
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Prepare the process
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  You are looking to answer this question: “If I had only one end user to represent our end-user profile, who would it be?”

Collect and analyze sales data, focusing on the most successful customers to date (maybe the 20% of customers generating 80% of the sales). Look at the primary market research you have already done, focusing on customers who would pay (not are just interested) in your potential offering.
Present a synthesis of all the research & findings to your team.
Present the end-user profile to your team.
Discuss with your team which end-user would be the best fit for a persona.
Consider separate personas for each customer type (for two- or multi-sided markets) but start with the end-user because if they don't use it, there is no value created.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_3">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_3"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_3"
                  >
                    Define the persona profile
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_3"
                  className="accordion-collapse collapse"
                  aria-labelledby="kt_accordion_1_header_3"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  Now you have to fill in all the details below as specifically as possible. Remember, the persona is a portrait of one specific end user. Do not give ranges (eg. 25–30 years old) but precise information (e.g. 27 years old). The list below contains just some suggestions. You should find those characteristics that make this persona unique as well.

                  Personal details
                  first and last name
                  photo
                  personal info (sex, age, education, family, born, raised)
                  Career context
                  job info (company, position, how many years in the job, training, salary, performance metrics if a B2B case etc.)
                  environment (managers, colleagues, challenges)
                  His/her story
                  likes
                  dislikes
                  behavior
                  socialization
                  hobbies/pastimes
                  information sources (web sites, blogs, Twitter, RSS etc.)
                  industry groups they belong to
                  water holes (i.e., where they congregate)
                  other relevant info
                  Purchasing criteria in prioritized order
                  highest priority criteria (probably what they fear most in the world)
                  medium priority criteria (probably what motivates them the most)
                  low priority criteria
                  irrelevant criteria
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_4">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_4"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_4"
                  >
                    Distribute the persona
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_4"
                  className="accordion-collapse collapse"
                  aria-labelledby="kt_accordion_1_header_4"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  The success of a persona relies in using it. Therefore, you must make sure everyone in your company knows what your customer looks like and is empathetic to his needs and pains.

                    We have consensus on the persona among the key members in our team.
                    The persona is displayed visibly in our office.
                    Everyone in our company or startup has an up-to-date copy of the persona.
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* end::Section */}

        </div>
        {/* end: Card Body */}
      </div>

  );
};

export { StepContent5 };
